module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('app-view', [_c('div', {
    staticClass: "content"
  }, _vm._l((_vm.notes), function(item, i) {
    return _c('a', {
      key: i,
      staticClass: "item",
      attrs: {
        "href": "javascript:;"
      },
      on: {
        "click": function($event) {
          return _vm.onEdit(i)
        },
        "&touchstart": function($event) {
          return _vm.onTouchStart(i)
        },
        "&touchmove": function($event) {
          return _vm.onTouchEnd.apply(null, arguments)
        },
        "&touchend": function($event) {
          return _vm.onTouchEnd.apply(null, arguments)
        }
      }
    }, [_c('div', [_c('span', [_vm._v(_vm._s(item.subtitle))]), _vm._v(" "), _c('span')]), _vm._v(" "), _c('div', [_c('span', [_vm._v(_vm._s(item.title))]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm._f("datetime")(item.addtime)))])])])
  }), 0), _vm._v(" "), (_vm.none) ? _c('div', {
    staticClass: "none"
  }, [_vm._v("暂时没有笔记")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "tip"
  }, [_vm._v("提示：长按可进行删除操作")]), _vm._v(" "), _c('app-confirm', {
    ref: "confirm"
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-44e5393a","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/view/note/index.vue
// module id = 321
// module chunks = 0